import ApiService from './../api/ApiService';
import Config from '../constants/Config';
import FareRule from '../models/FareRule';
import Urls from './../api/Urls';

export function getFareRule(params) {
    return new ApiService({
        baseURL: Config.API_FLIGHT,
        endpoint: Urls.FARE_RULE_LIST,
        params: params,
        parser: fareRulesDataParser,
    }).get();
}

export function getFareRuleDetail(id) {
    return new ApiService({
        baseURL: Config.API_FLIGHT,
        endpoint: Urls.FARE_RULE_DETAIL,
        endpointParams: { id },
        parser: (data) => new FareRule(data.data),
    }).get();
}

export function createFareRuleDetail(fareRule) {
    return new ApiService({
        baseURL: Config.API_FLIGHT,
        endpoint: Urls.FARE_RULE_ACTION,
        parser: (data) => new FareRule(data.fareRule),
    }).post(fareRule.export());
}

export function updateFareRuleDetail(fareRule) {
    return new ApiService({
        baseURL: Config.API_FLIGHT,
        endpoint: Urls.FARE_RULE_ACTION,
        parser: (data) => new FareRule(data.fareRule),
    }).put(fareRule.export());
}

export function deleteFareRuleDetail(fareRule) {
    return new ApiService({
        baseURL: Config.API_FLIGHT,
        endpoint: Urls.FARE_RULE_DETAIL,
        endpointParams: { id: fareRule.id }
    }).delete();
}

export function createFareRuleTranslate(fareRule) {
    return new ApiService({
        baseURL: Config.API_FLIGHT,
        endpoint: Urls.FARE_RULE_TRANSLATE_CREATE,
    }).post(fareRule.export(true).translate());
}

export function updateFareRuleTranslate(fareRule) {
    return new ApiService({
        baseURL: Config.API_FLIGHT,
        endpoint: Urls.FARE_RULE_TRANSLATE_UPDATE,
    }).put(fareRule.export(true).translate());
}

export function deleteFareRuleTranslate(id) {
    return new ApiService({
        baseURL: Config.API_FLIGHT,
        endpoint: Urls.FARE_RULE_TRANSLATE_DELETE,
        endpointParams: { id },
    }).delete();
}

const fareRulesDataParser = (data) => ({
    result: (data.data.result || []).map(item => new FareRule(item)),
    pageIndex: data.data.pageIndex,
    pageSize: data.data.pageSize,
    totalCount: data.data.totalCount
})